import React from "react";
import { Control } from "@assets/spa/control/text";
import { ControlWrap } from "@assets/spa/control/wrap";
import { Select } from "@assets/spa/control/select";
export function ForminatorAddress(props) {
    const { id, placeholder, onChange, value, values, errors, street_address_required, address_city, address_state, address_zip, address_country, address_line, street_address_label, countries, } = props;
    const subfields = [
        ['city', address_city],
        ['line', address_line, 'address_line'],
        ['state', address_state],
        ['zip', address_zip],
        ['country', address_country],
    ];
    const main_value = values[`${id}-street_address`];
    const main_message = errors[`${id}-street_address`];
    return React.createElement(React.Fragment, null,
        React.createElement(ControlWrap, { label: street_address_label, message: main_message, valid: !main_message, required: street_address_required === "1" },
            React.createElement(Control, { value: main_value || '', onChange: (value) => { onChange(value, `${id}-street_address`); }, placeholder: placeholder })),
        subfields.map(([name, show, submitName]) => {
            if (!show)
                return null;
            const subId = `${id}-${submitName || name}`;
            const value = values[subId];
            const message = errors[subId];
            return React.createElement(ControlWrap, { key: name, message: message, valid: !message, label: props[`address_${name}_label`], required: props[`address_${name}_required`] === '1' }, (name === 'country' && (countries === null || countries === void 0 ? void 0 : countries.length)) ? (React.createElement(Select, { options: countries, value: value, onChange: (value) => { onChange(value, `${id}-${submitName || name}`); }, placeholder: placeholder })) : (React.createElement(Control, { value: value || '', onChange: (value) => { onChange(value, `${id}-${submitName || name}`); }, placeholder: placeholder })));
        }));
}
ForminatorAddress.checkRequired = (props, values, __) => {
    const { id, street_address_required, street_address_required_message, } = props;
    const errors = {};
    if (street_address_required === "1") {
        const val = values[`${id}-street_address`];
        if (!val)
            errors[`${id}-street_address`] = street_address_required_message || __('Privalomas laukas', 'ltg-widgets');
    }
    [
        ['city'],
        ['line', 'address_line'],
        ['state'],
        ['zip'],
        ['country'],
    ].map(([name, submitName]) => {
        if (props[`address_${name}_required`] !== "1")
            return;
        if (!!values[`${id}-${submitName || name}`])
            return;
        errors[`${id}-${submitName || name}`] = props[`address_${name}_required_message`] || __('Privalomas laukas', 'ltg-widgets');
    });
    return errors;
};
